export const types = {
    SET_GET_DASHBOARD_VISITE: '[DASHBOARD] SET GET DASHBOARD VISITE',
    SET_GET_DASHBOARD_REPLENISHMENT: '[DASHBOARD] SET GET REPLENISHMENT',
    SET_GET_DASHBOARD_WITHDRAWALS: '[DASHBOARD] SET GET WITHDRAWALS'
}